
import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { Notification, createNotificationId } from './types';
import { addNotification } from '@/services/notificationService';

// Определяем функцию для получения аренд напрямую, без использования других хуков
const fetchCourierRentals = async (courierId: string | undefined) => {
  if (!courierId) return [];
  
  try {
    // Простая заглушка для демонстрации - позже можно заменить на реальный запрос
    // Здесь мы просто возвращаем пустой массив, чтобы избежать циклической зависимости
    return [];
  } catch (error) {
    console.error("Ошибка при загрузке аренд курьера:", error);
    return [];
  }
};

export const useRentalNotificationsFixed = () => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState<Notification[]>([]);
  
  // Получаем аренды напрямую, без вызова других хуков
  // Используем безопасный доступ к userId
  const userId = user?.id;
  
  const { data: rentals = [] } = useQuery({
    queryKey: ['courierRentals', userId],
    queryFn: () => fetchCourierRentals(userId),
    enabled: !!userId,
  });
  
  useEffect(() => {
    // Логика обработки уведомлений на основе аренд
    // Здесь будет реализована логика уведомлений
    
    // В качестве примера - проверка на активные аренды
    if (rentals.length > 0) {
      // Создаем уведомления
      const rentalNotifications = rentals
        .filter((rental: any) => rental.status === 'active')
        .map((rental: any) => ({
          id: createNotificationId('rental'),
          title: 'Активная аренда',
          message: `У вас активная аренда #${rental.human_number || rental.id.substring(0, 8)}`,
          timestamp: new Date().toISOString(),
          read: false,
          type: 'system' as const
        }));
      
      // Отображаем уведомления и добавляем их в общий реестр
      rentalNotifications.forEach(notification => {
        addNotification({
          title: notification.title,
          message: notification.message,
          type: notification.type,
          id: notification.id
        });
      });
      
      setNotifications(rentalNotifications);
    }
  }, [rentals]);
  
  // Функция для показа уведомлений устарела, но оставляем для обратной совместимости
  const showNotifications = () => {
    // Пустая реализация, все уведомления теперь добавляются в центральный сервис
    console.log("Метод устарел, используйте общий сервис уведомлений");
  };
  
  return {
    notifications,
    showNotifications,
    count: notifications.length,
  };
};
